<template>
  <div>
    <a
      v-if="content"
      target="_blank"
      class="clickable"
      title="Instructions"
      @click="showNotes(title, content)">
      <slot>
        <information-icon :title="'Instructions'" :fillColor="'#0069AA'" :size="18" />
      </slot>
    </a>
    <span v-else>-</span>
  </div>
</template>


<script>
  import {
    InformationIcon,
  } from '../../icons.js';
  
  export default {
    name: 'AsStatus',
    props: {
      
      props: {
        type: [Array, Object],
        required: true,
      },
      
      title: {
        type: String,
        default: 'Instructions'
      }
    },
    computed: {
      
      content () {
        let { row, column } = this.props;
        return row && column ? row[column] : '';
      }
    },
    methods: {
      
      showNotes (title, text) {
        this.$modal.show('dialog', {
          title,
          text,
          buttons: [
            {
              title: 'Close',
              class: 'vue-dialog-button reviewer-dialog-btn close-btn',
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        });
      }
    },
    
    data () {
      return {};
    },
    
    components: {
      InformationIcon
    }
  };
</script>
